import isEmpty from 'lodash/isEmpty'
import { orderPayQuery } from '../graphql'
import React from 'react'
import { useMutation } from '@ztechapps/common.hook'
import { useCheckoutContext } from '../index'

export const usePayNow = () => {
  const context = useCheckoutContext()
  const [shippingOptions] = context.shippingOptions
  const shippingFee = shippingOptions.shippingFee
  const isManualShippingRate = shippingOptions.isManualShippingRate
  const net = context.orderNetAmount
  const carrierRate = shippingOptions.carrierRate
  const message = context.message
  const { document } = context.orderDocumentResult

  const [payNow] = useMutation({ query: orderPayQuery })

  return React.useCallback(async () => {
    await payNow({
      input: {
        _id: document?._id,
        order: {
          _id: document?._id,
          shippingFee,
          isManualShippingRate,
          net,
          shipping: {
            rate: carrierRate,
          },
        },
        message: isEmpty(message) ? 'Please ship my order' : message,
      },
    })
  }, [payNow, document, shippingFee, isManualShippingRate, net, carrierRate, message])
}
